import { render, staticRenderFns } from "./detail2.vue?vue&type=template&id=73422421&scoped=true"
import script from "./detail2.vue?vue&type=script&lang=js"
export * from "./detail2.vue?vue&type=script&lang=js"
import style0 from "./detail2.vue?vue&type=style&index=0&id=73422421&prod&scoped=true&lang=less&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "73422421",
  null
  
)

export default component.exports